export const ASCII_LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
export const ASCII_UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const DIGITS = '0123456789';

export const ALPHANUMERIC_CHARS = ASCII_LOWERCASE + ASCII_UPPERCASE + DIGITS;
